import { PageSizeType, UserRolesType } from "@/app/model/types";

export interface IUser {
  id: string;
  email: string;
  fio: string;
  roleName: UserRolesType;
  dealerId: string;
  dealerName: string;
  registrationDate?: string;
  image?: string | null;
  blockedDate?: null | string;
  managerDealers?: IManagerDealer[];
}

export enum UserKeysEnum {
  id = "ИД",
  fio = "ФИО",
  email = "Адрес электронной почты",
  roleName = "Роль в системе",
  dealerId = "Ид дилера",
  dealerName = "Название дилера",
  registrationDate = "Дата регистрации",
  blockedDate = "Статус блокировки",
  image = " ",
  managerDealers = "",
}

export enum UserSortValuesEnum {
  fio,
  email,
  birthday,
  position,
  roleName,
}

export type StateSortType = {
  type: "desc" | "asc";
  field: keyof typeof UserSortValuesEnum;
};

export interface UserSliceState {
  usersList: IUser[];
  usersListForFilter: IUser[];
  error: null | string | unknown;
  sortRules: StateSortType;
  isLoading: boolean;
  miniLoading: boolean;
  hideUserColumnsList: string[];
  userForReview: IUser | null;
  searchCode: null | string;
  pageSize: PageSizeType;
  blockHistories: IBlockHistoryItem[];
}

export type UsersBodyType = {
  order: StateSortType;
  pagination?: {
    pageSize: number;
    pageNumber: number;
  };
  filters: [];
};

export type EditUserFieldsType = {
  id: string;
  firstName: string;
  lastName: string;
  middleName: string;
  role: UserRolesType;
  password?: string;
  confirmPassword?: string;
};

export interface IBlockHistoryItem {
  id: string;
  blockedAt: string;
  unblockedAt: string;
  blockedByUserId: string;
  blockedByUsername: string;
  unblockedByUserId: string;
  unblockedByUsername: string;
  blockComments: string;
  unblockComments: string;
}

export interface IManagerDealer {
  dealerId: string;
  name: string;
  shortName?: string | null;
  city?: string | null;
}

export interface ChangeManagerDealersResponse {
  userId: string;
  dealerIds: string[];
  user?: IUser;
}

export interface UsersResponse {
  items: IUser[];
}

export interface BlockHistoryResponse {
  data: IBlockHistoryItem[];
}
